import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasToken } from 'store/user/selectors';
import { useCurrentUser } from 'hooks/use-current-user.hook';
import { useSelector } from 'react-redux';
import { ERROR_PATH } from 'shared/consts';

interface PrivateRouteProps {
  children: JSX.Element;
  redirectTo?: string;
}

export const PrivateRoute = ({ redirectTo = ERROR_PATH, children }: PrivateRouteProps): JSX.Element | null => {
  const [currentUser, loading] = useCurrentUser();
  const isTokenStored = useSelector(hasToken);
  const navigate = useNavigate();

  const isAuthenticated = !!currentUser;
  const shouldRedirect = !isAuthenticated && !isTokenStored && !loading;

  useEffect(() => {
    if (shouldRedirect) {
      navigate(redirectTo, { replace: true });
    }
  }, [shouldRedirect, navigate, redirectTo]);

  if (isAuthenticated) {
    return children;
  }

  return null;
};
